import React, { useEffect, useState } from "react";
import { Button, Box, Typography, LinearProgress, DialogContent, Dialog, DialogTitle, IconButton, DialogActions, TextField, InputAdornment, InputLabel, MenuItem, Chip } from "@mui/material";
import { compound, createunit, featuress, placetype, unittypess } from "../../../components/Apis";
import "react-calendar/dist/Calendar.css";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import imageCompression from 'browser-image-compression';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Calendar, Select } from 'antd';
import dayjs from 'dayjs'; // ✅ Import dayjs
import isBetween from 'dayjs/plugin/isBetween'; // ✅ Import isBetween plugin
import RequestConfirmation from "../../../components/unitSuccess/Success";
import { useNavigate } from "react-router";
import SuccessPage from './SuccessPage'; // Import the SuccessPage component
import AddIcon from '@mui/icons-material/Add';


dayjs.extend(isBetween); // ✅ Extend dayjs with isBetween

const steps = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
];

const UnitSteps = ({ open, onClose, render }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [unittypes, setunittypes] = useState([]);
  const [selectedUnitType, setSelectedUnitType] = useState(null);
  const [placetypes, setplacetypes] = useState([])
  const [selecteplacetype, setSelecteplacetype] = useState(1);
  const [mapUrl, setMapUrl] = useState(null);
  const [mapDescription, setMapDescription] = useState(null);
  const [counts, setCounts] = useState({
    adults: 0,
    children: 0,
    pets: 0,
    bedrooms: 0,
    beds: 0,
    bathrooms: 0,
    beachPaths: 0,
  });
  const [features, setFeatures] = useState([]);
  const [selectedfeatures, setSelectedfeatures] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [images, setImages] = useState([]);
  const [tag, setTag] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);

  // Duplicate popup for images uploaded before
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [duplicateMessage, setDuplicateMessage] = useState("");
  // Duplicate popup for images uploaded before //
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [houseRules, setHouseRules] = useState("");
  const [note, setNote] = useState("");
  const [compounds, setcompounds] = useState([])
  const [compoundItem, setCompoundItem] = useState()
  const [checkInDate, setCheckInDate] = useState("09:00:00");
  const [checkOutDate, setCheckOutDate] = useState("10:00:00");
  const [isSuccess, setIsSuccess] = useState(false); // Track success state
  const navigate = useNavigate()

  // Add this state near the other state declarations
  const [offDays, setOffDays] = useState([]);

  // Add this state near the other state declarations
  const [sliderImages, setSliderImages] = useState([]);

  console.log("compoundItem", compoundItem)



  // const handleNext = () => {
  //   if (activeStep < steps.length - 1) {
  //     setActiveStep((prev) => prev + 1);
  //   }

  // };


  const handleNext = () => {
    let canProceed = false;

    switch (activeStep) {
      case 0:
        // canProceed = selectedUnitType !== null;
        canProceed = true;
        break;
      case 1:
        // canProceed = selecteplacetype !== null;
        canProceed = true;
        break;
      case 2:
        // canProceed = mapUrl !== null && mapDescription !== null;
        canProceed = true;
        break;
      case 3:
        // canProceed = Object.values(counts).some(count => count > 0);
        canProceed = true;
        break;
      case 4:
        // canProceed = selectedfeatures.length > 0;
        canProceed = true;
        break;
      case 5:
        // canProceed = startDate !== null && endDate !== null;
        canProceed = true;
        break;
      case 6:
        // canProceed = images.length >= 1;
        canProceed = true;
        break;
      case 7:
        // canProceed = offDays !== "";
        canProceed = true;
        break;
      case 8:
        // canProceed = offDays !== "";
        canProceed = true;
        break;
      // case 8:
      //   canProceed = description.trim() !== "";
      //   break;
      default:
        canProceed = true;
    }

    if (canProceed && activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    } else if (!canProceed) {
      setShowPopup(true);
    } else if (activeStep === steps.length - 1) {
      handleSubmit();
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const fetchunittypes = async () => {

    try {
      const response = await unittypess();
      setunittypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchplacetypes = async () => {
    try {
      const response = await placetype();
      console.log(response)
      setplacetypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchfeatures = async () => {

    try {
      const response = await featuress();
      console.log("my response", response)
      setFeatures(response)

    } catch (error) {
      console.error('Error fetching unit:', error);

    } finally {
    }
  };
  const fetchcompound = async () => {

    try {
      const response = await compound();
      console.log("setcompounds", response)
      setcompounds(response)
      if (response.length > 0) {
        setCompoundItem(response[0].id); // Set default to the first compound
      }
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };

  useEffect(() => {

    fetchunittypes()
    fetchplacetypes()
    fetchfeatures()
    fetchcompound()
  }, [])

  // Function to handle numbers of step 4
  const handleCountChange = (type, operation) => {
    setCounts((prevCounts) => ({
      ...prevCounts,
      [type]: operation === 'increment' ? prevCounts[type] + 1 : Math.max(prevCounts[type] - 1, 0),
    }));
  };
  // PopUp never go to next step without selection
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Function to handle image selection
  const handleImageChange = (event, type) => {
    const file = event.target.files[0];
    if (file) {
      if (type === "image") {
        setSelectedImage(file);
      }
      // else if (type === "icon") {
      //   setSelectedIcon(file);
      // }
      // Reset the input value to allow uploading the same file again
      event.target.value = '';
    }
  };

  // Function to remove an image
  const handleRemoveImage = (indexToRemove) => {
    setImages((prevImages) => prevImages.filter((_, index) => index !== indexToRemove));
  };
  // PopUp for images uploaded before
  const handleCloseDuplicatePopup = () => {
    setShowDuplicatePopup(false);
  };

  // ----------------------------- Strat New Calendar
  const onSelect = (value) => {
    const formattedDate = value.format("D-M-YYYY");
    
    if (!startDate) {
      // First click - set start date
      setStartDate(formattedDate);
      setEndDate(null);
    } else {
      // Second click - set end date
      setEndDate(formattedDate);
    }
  };
  const dateCellRender = (date) => {
    const formattedStartDate = startDate ? dayjs(startDate, "D-M-YYYY") : null;
    const formattedEndDate = endDate ? dayjs(endDate, "D-M-YYYY") : null;

    if (formattedStartDate && formattedEndDate) {
      if (date.isBetween(formattedStartDate, formattedEndDate, 'day', '[]')) {
        return <div style={{ background: '#cce5ff', height: "100%", width: "100%" }}></div>;
      }
    }
    if (formattedStartDate?.isSame(date, 'day')) {
      return <div style={{ background: '#60A9C6', color: 'white', height: "100%", width: "100%" }}></div>;
    }
    if (formattedEndDate?.isSame(date, 'day')) {
      return <div style={{ background: '#60A9C6', color: 'white', height: "100%", width: "100%" }}></div>;
    }
    return null;
  };
  // ----------------------------- End New Calendar

  // ----------------------------- Start New Images for tags
  const handleAddToState = () => {
    if (tag && selectedImage) {
      // Create a default icon if none is selected
      const defaultIcon = new File(
        [selectedImage], // Use the same image data
        'default-icon.png',
        { type: selectedImage.type }
      );

      const newEntry = {
        tag,
        image: selectedImage,
        icon: selectedIcon || defaultIcon // Use selectedIcon if available, otherwise use defaultIcon
      };

      setImages((prev) => [...prev, newEntry]);
      setTag("null");
      setSelectedImage("null");
      setSelectedIcon("null");
    } else {
      alert("Please provide a tag and an image.");
    }
  };

  const handleRemoveItem = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };
  // ----------------------------- End New Images

  // Add this function near the other calendar-related functions
  const onSelectOffDays = (value) => {
    const formattedDate = value.format("D-M-YYYY");

    setOffDays(prev => {
      if (prev.includes(formattedDate)) {
        return prev.filter(date => date !== formattedDate);
      } else {
        return [...prev, formattedDate];
      }
    });
  };

  // Add this function near your other calendar-related functions
  const disabledDate = (current) => {
    // Disable dates before today
    return current && current < dayjs().startOf('day');
  };

  // Update the calendar cell render function to include gray styling for disabled dates
  const offDaysCellRender = (date) => {
    const formattedDate = date.format("D-M-YYYY");

    // Check if date is before today
    if (date < dayjs().startOf('day')) {
      return <div style={{ background: '#e0e0e0', height: "100%", width: "100%", opacity: 0.5 }}></div>;
    }

    // Check if date is an off day
    if (offDays.includes(formattedDate)) {
      return <div style={{ background: '#ff0000', height: "100%", width: "100%", opacity: 0.3 }}></div>;
    }
    return null;
  };

  // Add these functions near the other image handling functions
  const handleSliderImageChange = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));
    setSliderImages(prev => [...prev, ...newImages]);
    // Reset the input value to allow uploading the same file again
    event.target.value = '';
  };

  const handleRemoveSliderImage = (indexToRemove) => {
    setSliderImages(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  // Update the handleSubmit function to include slider_images
  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("name", title || "");
      formData.append("description", description || "");
      formData.append("available_from", startDate);
      formData.append("available_to", endDate);
      formData.append("unit_type_id", selectedUnitType);
      formData.append("place_type_id", selecteplacetype);
      formData.append("location_url", mapUrl);
      formData.append("address", mapDescription);
      formData.append("house_rules", houseRules);
      formData.append("note", note);

      formData.append("adults", counts.adults);
      formData.append("children", counts.children);
      formData.append("pets", counts.pets);
      formData.append("bedrooms", counts.bedrooms);
      formData.append("bed", counts.beds);
      formData.append("bathrooms", counts.bathrooms);
      formData.append("beach_passes", counts.beachPaths);

      // Ensure images array is not empty before submitting of tag images
      // if (images.length === 0) {
      //   Swal.fire("Error", "Please add at least one image", "error");
      //   return;
      // }

      // Append each image with its tag and icon
      images.forEach((unit, index) => {
        formData.append(`images[${index}][tag]`, unit.tag);
        formData.append(`images[${index}][image]`, unit.image);
        formData.append(`images[${index}][icon]`, unit.icon);
      });

      // if (Array.isArray(images) && images.length > 0) {
      //   images.forEach((unit, index) => {
      //     if (unit?.tag) {
      //       formData.append(`images[${index}][tag]`, unit.tag);
      //     }

      //     if (unit?.image && typeof unit.image !== "string") {
      //       formData.append(`images[${index}][image]`, unit.image);
      //     }

      //     if (unit?.icon && typeof unit.icon !== "string") {
      //       formData.append(`images[${index}][icon]`, unit.icon);
      //     }
      //   });
      // }


      if (selectedfeatures) {
        selectedfeatures.forEach((feature, index) => {
          formData.append(`features_id[${index}]`, feature);
        });
      }

      // Check-in and check-out dates
      formData.append("check_in", checkInDate || "");
      formData.append("check_out", checkOutDate || "");

      // Add compound_id if required
      formData.append("compound_id", compoundItem || "");

      // Add off days to formData
      offDays.forEach((date, index) => {
        formData.append(`off_days[${index}]`, date);
      });

      // Add slider images to formData
      sliderImages.forEach((image, index) => {
        formData.append(`slider_images[${index}]`, image.file);
      });

      Swal.showLoading();
      const res = await createunit(formData);
      console.log("res", res);
      console.log("res.success", res.success);
      console.log("typeof res.success", typeof res.success);
      Swal.close();

      // Check if res exists and has success property
      if (res && res.success === true) {
        console.log("Success condition met");
        await Swal.fire({
          title: "Success",
          text: "Unit Created Successfully",
          icon: "success"
        });
        navigate("/units"); // سينتقل إلى الصفحة بعد إغلاق التنبيه
        render();
      } else {
        console.log("Error condition met");
        // Only show error if we have an error message
        const errorMessage = res?.message || "Failed to create unit";
        Swal.fire("Error", errorMessage, "error");
      }
    } catch (error) {
      // console.error("Error creating unit:", error);
      // Swal.fire("Error", "Failed to create unit", "error");
    }

  };


  return (

    <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", paddingTop: "4rem", direction: "ltr", backgroundColor: "var(--seco-col)", position: "relative" }}>
      <p style={{ width: '100%', textAlign: "left", fontSize: "24px", fontWeight: "600", marginLeft: "3rem" }}> Add Request </p>
      <div className="addSteps" style={{ width: "60%", marginBottom: "2rem"}}>
        <div>
          {/* Step Title */}
          <LinearProgress
            variant="determinate"
            value={((activeStep + 1) / steps.length) * 100}
            sx={{
              height: 12,
              borderRadius: 5,
              backgroundColor: "#D3C1B2", // اللون الرمادي للخلفية
              "& .MuiLinearProgress-bar": {
                backgroundColor: "var(--pri-col)", // ✅ تغيير اللون الأزرق إلى اللون المطلوب
              },
            }} />
          {/* Progress Bar */}
          <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, mt: 2, textAlign: "center" }}>
            Step {activeStep + 1} of {steps.length}
          </Typography>
          {/* <Typography variant="h5" sx={{ mb: 4, fontWeight: "bold", textAlign: "center" }}>
            {steps[activeStep]}
          </Typography> */}
        </div>


        {/* Step Content */}
        {/* ------------------------------------------   Step 1 */}
   {/* Step 1 - Unit Types */}
        {activeStep === 0 && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "auto", 
            width: "100%", 
            marginTop: "1rem" 
          }}>
            <p style={{ 
              fontSize: "clamp(24px, 5vw, 32px)", 
              fontWeight: "600",
              marginBottom: "1rem"
            }}> What kind of place will guests have? </p>
            <div style={{ 
              width: "100%", 
              height: "auto", 
              display: "flex", 
              flexWrap: "wrap", 
              gap: "1rem",
              justifyContent: "center"
            }}>
              {unittypes?.map((ele) => (
                <div
                  key={ele.id}
                  style={{
                    width: "clamp(250px, 30%, 300px)",
                    height: "150px",
                    display: "flex",
                    alignItems: "flex-start",
                    padding: "10px",
                    border: "1px solid #F3EBE8",
                    marginTop: "1rem",
                    cursor: "pointer",
                    borderRadius: "12px",
                    backgroundColor: selectedUnitType === ele.id ? "rgba(96, 169, 198, 0.12)" : "#FFF",
                    border: selectedUnitType === ele.id ? "1px solid #60A9C6" : "1px solid #EAEBEE",
                    position: "relative",
                    transition: "all 0.3s ease",
                    '@media (max-width: 600px)': {
                      width: "100%",
                      height: "120px"
                    }
                  }}
                  onClick={() => setSelectedUnitType(ele.id)}
                >
                  <p style={{ 
                    fontSize: "clamp(16px, 4vw, 20px)", 
                    fontWeight: "400" 
                  }}>
                    <img 
                      src={ele.icon} 
                      alt="Icon" 
                      loading="lazy" 
                      style={{ 
                        width: "20px", 
                        height: "20px", 
                        marginRight: "7px" 
                      }} 
                    />
                    {ele.unit_type}
                  </p>
                  {selectedUnitType === ele.id && (
                    <CheckCircleIcon
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        color: "#60A9C6",
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 2 */}
        {/* {activeStep === 1 && (<>
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> What type of place will guests have ?</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              {placetypes?.map((ele) => (
                <div
                  key={ele.id}
                  style={{
                    width: "90%",
                    height: "100px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "10px",
                    border: "1px solid #F3EBE8",
                    marginTop: "0rem",
                    cursor: "pointer",
                    borderRadius: "8px",
                    backgroundColor: selecteplacetype === ele.id ? "rgba(96, 169, 198, 0.12)" : "#FFF",
                    border: selecteplacetype === ele.id ? "1px solid #60A9C6" : "1px solid #F3EBE8",
                    position: "relative"

                  }}
                  onClick={() => setSelecteplacetype(ele.id)}
                >


                  <p style={{ fontSize: "20px", fontWeight: "400" }}>
                    <img src={ele.icon} alt="Icon" loading="lazy" style={{ width: "20px", height: "20px", marginRight: "5px" }} />{ele.place_type}
                  </p>
                  {selecteplacetype === ele.id && (
                    <CheckCircleIcon
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        color: "#60A9C6",
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                      }}
                    />
                  )}
                  {ele.place_type === "An entire place" && (
                    <p style={{ fontSize: "14px", fontWeight: "400", color: "#667085", marginLeft: "1.6rem" }}>
                      Guests have the whole place to themselves.
                    </p>
                  )}

                  {ele.place_type === "Room" && (
                    <p style={{ fontSize: "14px", fontWeight: "400", color: "#667085", marginLeft: "1.6rem" }}>
                      Guests have their own room in a home, plus access to shared spaces.
                    </p>
                  )}

                  {ele.place_type === "Shared room" && (
                    <p style={{ fontSize: "14px", fontWeight: "400", color: "#667085", marginLeft: "1.6rem" }}>
                      Guests sleep in a room or common area that may be shared with you or others.
                    </p>
                  )}


                </div>
              ))}
            </div>
          </div>
        </>)
        } */}
        {/* ------------------------------------------   Step 3 */}
        {activeStep === 1 && (<>
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> Where's your place located ?</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}> Your address is only shared with guests after they've made a reservation.</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              <TextField
                name="Map_url"
                label="Location Url"
                type="text"
                sx={{ width: '100%' }}
                margin="normal"
                value={mapUrl}
                onChange={(e) => setMapUrl(e.target.value)}
              />
              <TextField
                name="description"
                label="Address"
                type="text"
                sx={{ width: '100%' }}
                margin="normal"
                value={mapDescription}
                onChange={(e) => setMapDescription(e.target.value)}
              />
            </div>
          </div>
        </>)
        }
        {/* ------------------------------------------   Step 4 */}
        {activeStep === 2 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>How many people can stay here?</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "1rem", backgroundColor: "#fff", borderRadius: "5px" }}>
              {Object.entries(counts).map(([key, value]) => (
                <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingInline: "10px" }}>
                  <div>
                    <p style={{ fontSize: "20px", fontWeight: "400" }}>{key.charAt(0).toUpperCase() + key.slice(1)}</p>
                    <p style={{ fontSize: "12px", color: "#615C5A" }}>{key === 'adults' ? 'Age 13+' : key === 'children' ? 'Ages 2-12' : ''}</p>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button onClick={() => handleCountChange(key, 'decrement')} style={{ border: "none", backgroundColor: "transparent", fontWeight: "bold", zIndex: 99 }}>-</button>
                    <span style={{ margin: "0 10px", fontWeight: "bold" }}>{value}</span>
                    <button onClick={() => handleCountChange(key, 'increment')} style={{ border: "none", backgroundColor: "transparent", fontWeight: "bold", zIndex: 99 }}>+</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 5 */}
        {activeStep === 3 && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "auto", 
            width: "100%", 
            marginTop: "1rem" 
          }}>
            <p style={{ 
              fontSize: "clamp(24px, 5vw, 32px)", 
              fontWeight: "600",
              marginBottom: "1rem"
            }}> 
              Which of these best describes your place?
            </p>
            <div style={{ 
              width: "100%", 
              height: "auto", 
              display: "flex", 
              flexWrap: "wrap", 
              gap: "1rem",
              justifyContent: "center"
            }}>
              {features?.map((ele) => (
                <div
                  key={ele.id}
                  style={{
                    width: "clamp(250px, 30%, 300px)",
                    height: "150px",
                    display: "flex",
                    alignItems: "flex-start",
                    padding: "10px",
                    border: "1px solid #F3EBE8",
                    marginTop: "1rem",
                    cursor: "pointer",
                    borderRadius: "12px",
                    backgroundColor: selectedfeatures.includes(ele.id) ? "rgba(96, 169, 198, 0.12)" : "#FFF",
                    border: selectedfeatures.includes(ele.id) ? "1px solid #60A9C6" : "1px solid #EAEBEE",
                    position: "relative",
                    transition: "all 0.3s ease",
                    '@media (max-width: 600px)': {
                      width: "100%",
                      height: "120px"
                    }
                  }}
                  onClick={() => {
                    setSelectedfeatures((prevSelected) => {
                      if (prevSelected.includes(ele.id)) {
                        return prevSelected.filter(id => id !== ele.id);
                      } else {
                        return [...prevSelected, ele.id];
                      }
                    });
                  }}
                >
                  <p style={{ 
                    fontSize: "clamp(16px, 4vw, 20px)", 
                    fontWeight: "400" 
                  }}>
                    <img 
                      src={ele.icon} 
                      alt="Icon" 
                      loading="lazy" 
                      style={{ 
                        width: "20px", 
                        height: "20px", 
                        marginRight: "7px" 
                      }} 
                    />
                    {ele.feature}
                  </p>
                  {selectedfeatures.includes(ele.id) && (
                    <CheckCircleIcon
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        color: "#60A9C6",
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 6 Calendar */}
        {activeStep === 4 && (<>
          <p style={{ fontSize: "32px", fontWeight: "600" }}>Select Available Days</p>
          <Calendar 
            onSelect={onSelect} 
            dateCellRender={dateCellRender} 
            style={{ borderRadius: "12px", overflow: "hidden" }}
          />
        </>)}
        {/* ------------------------------------------   Step 7 OFF Days */}
        {activeStep === 5 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "120vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Select Off Days</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>
              Click on dates to mark them as off days. Click again to unmark.
            </p>
            <Calendar
              onSelect={onSelectOffDays}
              dateCellRender={offDaysCellRender}
              disabledDate={disabledDate}
              style={{ borderRadius: "12px", overflow: "hidden" }}
            />
            <div style={{ marginTop: "1rem" }}>
              <Typography variant="h6">Selected Off Days:</Typography>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "0.5rem" }}>
                {offDays.map((date, index) => (
                  <Chip
                    key={index}
                    label={date}
                    onDelete={() => setOffDays(prev => prev.filter(d => d !== date))}
                    sx={{ backgroundColor: "#ffcccc" }}
                  />
                ))}
              </div>
            </div>
          </div >
        )}
        {/* ------------------------------------------   Step 8 */}
        {/* {activeStep === 6 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem", alignItems: "flex-start" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> Add some photos of your house </p>
            <TextField
              label="Write a tag..."
              variant="outlined"
              fullWidth
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EditIcon />
                  </InputAdornment>
                ),
              }}
            />
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "3rem", marginBottom: "1rem", marginTop: "1rem" }}>
              <label htmlFor="upload-image" style={uploadStyle}>

                <input type="file" id="upload-image" style={{ display: "none" }} accept="image/*" onChange={(e) => handleImageChange(e, "image")} />
                <span style={iconStyle}>Image</span>
              </label>
              <IconButton
                onClick={handleAddToState}
                sx={{
                  zIndex: "5",
                  border: '1px dashed var(--pri-col)',
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#fff",
                  }
                }}
              >
                <AddIcon style={{
                  color: "#C47D60", fontSize: "3rem",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#fff",
                  }
                }} />
              </IconButton>
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1rem" }}>
              {selectedImage && (
                <div style={{ position: "relative" }}>
                  <img src={URL.createObjectURL(selectedImage)} alt="Selected Image" style={imgStyle} />
                  <button onClick={() => setSelectedImage(null)} style={removeBtnStyle}>&times;</button>
                </div>
              )}
            </div>


            <div style={{ marginTop: "2rem", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              {images.map((item, index) => (
                <div key={index} style={{ position: "relative", border: "1px solid #ddd", padding: "10px", borderRadius: "5px" }}>
                  <p style={{ fontWeight: "bold", textAlign: "center" }}>{item.tag}</p>
                  <img src={URL.createObjectURL(item.image)} alt={`upload-${index}`} style={imgStyle} />
                  <button onClick={() => handleRemoveItem(index)} style={removeBtnStyle}>&times;</button>
                </div>
              ))}
            </div>
          </div>
        )} */}
        {/* ------------------------------------------   Step 9 */}
        {activeStep === 6 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%",minHeight:"70vh", height: "auto", marginTop: "1rem", alignItems: "flex-start" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Add Slider Images</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>
              Upload multiple images for your unit's slider. You can add or remove images as needed.
            </p>

            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1rem" }}>
              <label htmlFor="upload-slider-images" style={uploadStyle}>
                <input
                  type="file"
                  id="upload-slider-images"
                  style={{ display: "none" }}
                  accept="image/*"
                  multiple
                  onChange={handleSliderImageChange}
                />
                <span style={iconStyle}>Images</span>
              </label>
            </div>

            {/* Display Uploaded Slider Images */}
            <div style={{
              marginTop: "2rem",
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "flex-start"
            }}>
              {sliderImages.map((image, index) => (
                <div key={index} style={{ position: "relative" }}>
                  <img
                    src={image.preview}
                    alt={`slider-${index}`}
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      borderRadius: "5px"
                    }}
                  />
                  <button
                    onClick={() => handleRemoveSliderImage(index)}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "16px"
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ------------------------------------------   Step 10 */}
        {activeStep === 7 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem", alignItems: "flex-start" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Add a title for your house</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>Short titles work best. You can always change it later.</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1rem" }}>
              <TextField
                label="Write a title..."
                variant="outlined"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>

                  ),
                }}
              />
            </div >
          </div >
        )}
        {/* ------------------------------------------   Step 11 */}
        {activeStep === 8 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem", alignItems: "flex-start" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Create your description</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}> Share what makes your place special.</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1rem" }}>
              <TextField
                label="Write a description..."
                variant="outlined"
                fullWidth
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Write a House Roules..."
                variant="outlined"
                fullWidth
                value={houseRules}
                onChange={(e) => setHouseRules(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Write a Note..."
                variant="outlined"
                fullWidth
                value={note}
                onChange={(e) => setNote(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
              {/* <InputLabel
                sx={{
                  backgroundColor: "white",
                  px: 1, // Padding left and right to cover the border
                  "&.Mui-focused": {
                    backgroundColor: "white",
                  }
                }}>Compounds</InputLabel> */}
              {/* <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}> Compounds</p> */}
              <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, mt: 2, textAlign: "left" }}>
            Compounds 
          </Typography>
              <Select
                name="compound_id"
                value={compoundItem} // The value will be the selected compound's ID
                onChange={(e) => setCompoundItem(e)} // Set the selected compound id
                sx={{direction:"ltr"}}
              >
                {compounds.length > 0 ? (
                  compounds.map((type, index) => (
                    <MenuItem key={index} value={type.id} sx={{direction:"ltr"}}> {/* `value` is the compound id */}

                      {type.compound} {/* Displaying the compound name */}
                    </MenuItem>

                  ))
                ) : (
                  <MenuItem value="">No compounds available</MenuItem> // Fallback message when no compounds
                )}
              </Select>

            </div>
          </div>
        )}







        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, backgroundColor: "var(--seco-col)" }}>
          <Button
            onClick={handleBack}
            disabled={activeStep === 0}
            sx={{
              backgroundColor: "var(--pri-col)",
              color: "white",
              px: 4,
              '&:hover': {
                backgroundColor: "#8b3e2a",
              }
            }}
          >
            Back
          </Button>
          <Button
            onClick={handleNext}
            sx={{
              backgroundColor: "var(--pri-col)",
              color: "white",
              px: 4,
              '&:hover': {
                backgroundColor: "#8b3e2a",
              }
            }}
          >
            {activeStep === steps.length - 1 ? "Done" : "Next"}
          </Button>
        </Box>
      </div>

      <Dialog open={showPopup} onClose={handleClosePopup} dir="rtl">
        <DialogTitle>{"Can't move to the next step Without selected properties"}</DialogTitle>
        <DialogActions sx={{ justifyContent: "center" }}> {/* Center the button */}
          <Button
            onClick={handleClosePopup}
            sx={{ backgroundColor: "var(--pri-col)", color: "white", "&:hover": { backgroundColor: "#A86950" } }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showDuplicatePopup} onClose={handleCloseDuplicatePopup} sx={{ direction: "rtl", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <DialogContent >
          <Typography>{duplicateMessage}</Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={handleCloseDuplicatePopup}
            sx={{ backgroundColor: "#C47D60", color: "white", "&:hover": { backgroundColor: "#A86950" } }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <img src="../../assets/image 2 (1).png" style={{ width: "250px", height: "250px", position: "absolute", top: "0px", right: "0px", zIndex: "1", transform: "rotate(0deg)", }} />

      {isSuccess && (
        <SuccessPage /> // Render the SuccessPage component
      )}

    </div>


  );
};

const uploadStyle = { cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", border: "10px dashed #60A9C6", borderRadius: "50%", width: "150px", height: "150px", position: "relative" };
const iconStyle = { fontSize: "20px", color: "#60A9C6", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
const buttonStyle = { padding: "10px 20px", background: "var(--pri-col)", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" };
const imgStyle = { width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" };
const iconImgStyle = { width: "50px", height: "50px", objectFit: "cover", borderRadius: "5px", marginLeft: "10px" };
const removeBtnStyle = { position: "absolute", top: "5px", right: "5px", backgroundColor: "rgba(0, 0, 0, 0.5)", color: "white", border: "none", borderRadius: "50%", width: "20px", height: "20px", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" };


export default UnitSteps;
